import { GraphQL } from '@guestgoodie/graphql'
import { Tick01Icon } from '@hugeicons/core-solid-rounded'
import { Trans } from '@lingui/react/macro'

import Button from '@/components/ui/Button'
import { ReadIcon } from './ReadIcon'
import { useMarkAsRead } from '../hooks/useMarkAsRead'

export function FeedbackReadInfo({
  item
}: {
  item: GraphQL.SimpleFeedbackFragmentFragment
}) {
  const { markAsRead, loading } = useMarkAsRead(item)

  return (
    <div>
      {!item.isRead && (
        <div className="flex flex-row items-center">
          <Button Icon={Tick01Icon} onClick={markAsRead} loading={loading}>
            <Trans>Mark as Read</Trans>
          </Button>
        </div>
      )}
      {item.isRead && (
        <div className="flex flex-row items-center">
          <ReadIcon item={item} />
        </div>
      )}
    </div>
  )
}
